export const MARKERS_ACTIONS = {
    FIND: 'FIND_MARKERS',
    GET: 'GET_MARKERS',
    GET_LIST: 'GET_MARKERS_LIST',
    CHANGE_STATUS: 'CHANGE_STATUS_MARKERS',
    SUCCESS: 'SUCCESS_MARKERS',
    ERROR: 'ERROR_MARKERS',
    CLEAN: 'CLEAN_MARKERS',

    SUGGESTION: 'SUGGESTION',
    SUGGESTION_CLEAN: 'SUGGESTION_CLEAN'
}